var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { styled } from 'styled-components';
import { Accordion } from './Accordion';
import { ContentContainer, ContentInfoContainer, HeaderText, Image, Info, Title, } from './Common';
import expUrl from '../images/students-experience.png';
import { PlayIcon } from '../images/icons';
var ScPlayIcon = styled(PlayIcon).withConfig({ displayName: "ScPlayIcon", componentId: "sc-5fv4dv" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n"], ["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n"])));
var ImageContainer = styled.div.withConfig({ displayName: "ImageContainer", componentId: "sc-oaz3hc" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  height: 100%;\n  & > img {\n    width: 488px;\n    height: 275px;\n  }\n  cursor: pointer;\n  &:hover {\n    ", " > path:first-child {\n      fill: #e80949;\n    }\n  }\n"], ["\n  position: relative;\n  height: 100%;\n  & > img {\n    width: 488px;\n    height: 275px;\n  }\n  cursor: pointer;\n  &:hover {\n    ", " > path:first-child {\n      fill: #e80949;\n    }\n  }\n"])), ScPlayIcon);
var StudentExperienceAccordion = function (_a) {
    var groupId = _a.groupId, checked = _a.checked, onOpen = _a.onOpen, rest = __rest(_a, ["groupId", "checked", "onOpen"]);
    return (_jsx(Accordion, __assign({}, rest, { label: 'Student experience', checked: checked, header: _jsx(HeaderText, { children: "Watch a short video to understand the student experience" }, void 0) }, { children: _jsx(Content, { onOpen: onOpen }, void 0) }), void 0));
};
var ScInfo = styled(Info).withConfig({ displayName: "ScInfo", componentId: "sc-1ceos3l" })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  text-align: left;\n"], ["\n  text-align: left;\n"])));
var Content = function (_a) {
    var onOpen = _a.onOpen;
    var handleOnPlay = useCallback(function () {
        if (onOpen)
            onOpen();
    }, [onOpen]);
    return (_jsxs(ContentContainer, { children: [_jsxs(ContentInfoContainer, { children: [_jsxs(Title, { children: ["Watch a short video to discover", _jsx("br", {}, void 0), "the student experience on Happy Numbers"] }, void 0), _jsx(ScInfo, { children: "Discover the Happy Numbers student experience with Jacob, and see how our technology scaffolds learning, providing just the right amount of guidance and practice to keep students in their Zone of Proximal Development, moving them toward ever-more complex math skills." }, void 0)] }, void 0), _jsxs(ImageContainer, __assign({ onClick: handleOnPlay }, { children: [_jsx(Image, { src: expUrl, alt: 'experience' }, void 0), _jsx(ScPlayIcon, {}, void 0)] }), void 0)] }, void 0));
};
export { StudentExperienceAccordion };
var templateObject_1, templateObject_2, templateObject_3;
